<template>
  <div class="c-details__wrap">
    <slot></slot>
  </div>
</template>

<script setup>
import { provide, ref } from 'vue';

const props = defineProps({
  /**
   * Name attribute for grouping details elements
   * When provided, only one accordion in the group can be open at a time
   * ALWAYS recommended - even for single accordions for semantic consistency
   */
  name: {
    type: String,
    default: null
  },

  /**
   * Whether to allow multiple accordions to be open simultaneously
   * When false and name is provided, accordion behavior becomes exclusive (radio-like)
   */
  allowMultiple: {
    type: Boolean,
    default: true
  }
});

// Provide the group configuration to child accordion components
provide('accordionGroup', {
  name: props.name,
  allowMultiple: props.allowMultiple
});
</script>

<style scoped>
/*
 * Uses Illinois State CSS framework c-details__wrap styling
 * Provides semantic grouping and structural styling for accordion collections
 * Additional custom styling can be added here if needed for specific use cases
 */
</style>